import { valueProps } from '@/mocks/siteContent';

export default function ValueSection() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-10">
          <span className="text-xs md:text-sm label-font text-primary-600 tracking-[0.2em]">
            WHY US
          </span>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            为什么用合集的方式爆料
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            单条动态看完还是一头雾水，合集把散落的信息重新排好顺序，你只需要顺着往下读。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {valueProps.map((item) => (
            <div
              key={item.title}
              className="p-5 md:p-6 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}